import { Builder } from './builders';
import { Container } from './container';
import { All, AutoInject, Dependencies, Factory, Inject, Lazy, NewInstance, Optional, Parent, Resolve, Scoped, Singleton, Transient, } from './decorators';
export * from './container';
export * from './decorators';
export * from './protocol/protocol';
export * from './types';
export { Builder, Container };
export default {
    Builder,
    Container,
    All,
    AutoInject,
    Dependencies,
    Factory,
    Lazy,
    Inject,
    NewInstance,
    Optional,
    Parent,
    Resolve,
    Scoped,
    Singleton,
    Transient,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sWUFBWSxDQUFDO0FBQ3JDLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxhQUFhLENBQUM7QUFDeEMsT0FBTyxFQUNILEdBQUcsRUFDSCxVQUFVLEVBQ1YsWUFBWSxFQUNaLE9BQU8sRUFDUCxNQUFNLEVBQ04sSUFBSSxFQUNKLFdBQVcsRUFDWCxRQUFRLEVBQ1IsTUFBTSxFQUNOLE9BQU8sRUFDUCxNQUFNLEVBQ04sU0FBUyxFQUNULFNBQVMsR0FDWixNQUFNLGNBQWMsQ0FBQztBQUV0QixjQUFjLGFBQWEsQ0FBQztBQUM1QixjQUFjLGNBQWMsQ0FBQztBQUM3QixjQUFjLHFCQUFxQixDQUFDO0FBQ3BDLGNBQWMsU0FBUyxDQUFDO0FBQ3hCLE9BQU8sRUFBRSxPQUFPLEVBQUUsU0FBUyxFQUFFLENBQUM7QUFFOUIsZUFBZTtJQUNYLE9BQU87SUFDUCxTQUFTO0lBQ1QsR0FBRztJQUNILFVBQVU7SUFDVixZQUFZO0lBQ1osT0FBTztJQUNQLElBQUk7SUFDSixNQUFNO0lBQ04sV0FBVztJQUNYLFFBQVE7SUFDUixNQUFNO0lBQ04sT0FBTztJQUNQLE1BQU07SUFDTixTQUFTO0lBQ1QsU0FBUztDQUNaLENBQUMifQ==